import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import SkillNode from "../SkillNode";

export default class MinedDamageBonusSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {Values} values
     * @param {number} purchaseIndex Starts at 0
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, values, purchaseIndex) {
        super(id, 'Mined Damage +' + NumberFormatter.formatNumber(Settings.minedDamage.baseBonusPerUpgrade + (Settings.minedDamage.incrementBonusPerUpgrade * purchaseIndex)), 
            null, totals, iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
        /**
         * @constant
         * @type {number}
         */
        this.purchaseIndex = purchaseIndex;
    }

    /**
     * @returns {string}
     */
    getDescription() {
        const bonus = this.values.skillMinedDamageBonus.getValue();
        return 'Bonus: +' + NumberFormatter.formatNumber(bonus);
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.applyUpgrade();
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.applyUpgrade();
        super.onPurchaseFromSave();
    }

    /**
     * @private
     */
    applyUpgrade() {
        const bonus = Settings.minedDamage.baseBonusPerUpgrade + (Settings.minedDamage.incrementBonusPerUpgrade * this.purchaseIndex);
        this.values.skillMinedDamageBonus.incrementValue(bonus);
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        super.resetFull();
        this.values.skillMinedDamageBonus.reset();
    }

}